/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 運用基準詳細
 */
export type OperationCriteriaDetailEnum =
  (typeof OperationCriteriaDetailEnum)[keyof typeof OperationCriteriaDetailEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OperationCriteriaDetailEnum = {
  CRITICAL: 'CRITICAL',
  MYOCARDIAL_INFARCTION: 'MYOCARDIAL_INFARCTION',
  STROKE: 'STROKE',
  SEVERE_TRAUMA: 'SEVERE_TRAUMA',
  PREGNANT: 'PREGNANT',
  PEDIATRIC: 'PEDIATRIC',
} as const;
